const getUsersReducer = (state = null, action) => {
    switch (action.type) {
        case "GET_USERS":
            return action.payload;
        default:
            return state;
    }
};
export default getUsersReducer;
